import l from '../../../../lang';
import TopDashboardSection from '../../../common/top-dashboard-section';
import Card from '../../../common/card';
import CreatedQRPay from '../created/qr-pay';

const QRPaymentPage = () => (
  <div className="created_payment_links">
    <TopDashboardSection title={l('menu.subItem.QR_PAYMENT')} subtitle={l('qrPayment.page.subheadline')} />
    <Card>
      <CreatedQRPay />
    </Card>
  </div>
);

export default QRPaymentPage;
